import logUtil from 'utils/log'
import updateCurrentProductIdAction from 'modules/product/redux/actions/update-current'
import updateCurrentVariantIdAction from 'modules/variant/redux/actions/update-current'
import getProductIdFromUrlProductUtil from 'modules/product/utils/get-product-id-from-url'
import getVariantIdFromUrlProductUtil from 'modules/product/utils/get-variant-id-from-url'
// import getParentProductFromUrlByVariantIdProductSelector from 'modules/product/redux/selectors/get-parent-product-from-url-by-variant-id'

export default function updateCurrentProductAndVariantIdFromUrlProductAction () {
  return (dispatch) => {
    const logLabel = 'updateCurrentProductAndVariantIdFromUrlProductAction'

    const productIdFromUrl = getProductIdFromUrlProductUtil()
    const variantIdFromUrl = getVariantIdFromUrlProductUtil()

    const debugProps = {
      productIdFromUrl,
      variantIdFromUrl
    }
    logUtil(logLabel).debug('[start] debugProps=', debugProps)

    if (productIdFromUrl) {
      dispatch(
        updateCurrentProductIdAction(
          Number(productIdFromUrl)
        )
      )
    }

    if (variantIdFromUrl) {
      dispatch(
        updateCurrentVariantIdAction(
          Number(variantIdFromUrl)
        )
      )
    }
  }
}
